import React from 'react';
import logoTransferIsOk from '../img/newlogo.png';

/**
 * Página que se muestra cuando hay un error en el proceso de OAuth con MercadoPago
 * El usuario ya fue registrado parcialmente en Firestore y se envió notificación a Telegram
 */
function RegistroError() {
    return (
        <div className="login-container" style={{
            backgroundColor: '#001c4d',
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div className="login-card" style={{
                backgroundColor: 'white',
                borderRadius: '10px',
                padding: '30px',
                maxWidth: '500px',
                width: '90%',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
            }}>
                <div className="login-logo" style={{
                    textAlign: 'center',
                    marginBottom: '30px'
                }}>
                    <img
                        src={logoTransferIsOk}
                        alt="TransferisOK Logo"
                        style={{
                            maxWidth: '250px',
                            width: '100%'
                        }}
                    />
                </div>

                <h2 style={{
                    textAlign: 'center',
                    color: '#001c4d',
                    fontSize: '28px',
                    marginBottom: '20px'
                }}>Gracias por registrarte</h2>

                <div className="warning-message" style={{
                    backgroundColor: '#fff3cd',
                    padding: '20px',
                    borderRadius: '5px',
                    textAlign: 'center',
                    marginBottom: '20px',
                    border: '1px solid #ffc107'
                }}>
                    <div style={{
                        fontSize: '48px',
                        marginBottom: '15px'
                    }}>
                        ⚠️
                    </div>
                    <p style={{
                        fontSize: '16px',
                        color: '#856404',
                        margin: '0 0 15px 0',
                        lineHeight: '1.6'
                    }}>
                        Lamentablemente no pudimos conectar con tu cuenta de Mercado Pago en este momento.
                    </p>
                    <p style={{
                        fontSize: '16px',
                        color: '#856404',
                        margin: '0',
                        lineHeight: '1.6',
                        fontWeight: 'bold'
                    }}>
                        No te preocupes, ya recibimos tus datos y te contactaremos a la brevedad para ayudarte a completar tu registro.
                    </p>
                </div>

                <div className="info-box" style={{
                    backgroundColor: '#e3f2fd',
                    padding: '20px',
                    borderRadius: '5px',
                    marginBottom: '20px',
                    border: '1px solid #2196f3'
                }}>
                    <h3 style={{
                        fontSize: '18px',
                        color: '#1565c0',
                        marginTop: '0',
                        marginBottom: '15px',
                        textAlign: 'center'
                    }}>¿Qué pasará ahora?</h3>
                    <ul style={{
                        textAlign: 'left',
                        color: '#0d47a1',
                        lineHeight: '1.8',
                        paddingLeft: '20px',
                        margin: '0'
                    }}>
                        <li>Nuestro equipo ya recibió una notificación con tus datos</li>
                        <li>Te contactaremos por email o teléfono en las próximas horas</li>
                        <li>Te ayudaremos a completar la conexión con Mercado Pago</li>
                        <li>Una vez solucionado, podrás acceder a tu cuenta sin problemas</li>
                    </ul>
                </div>

                <div style={{
                    textAlign: 'center',
                    color: '#64748b',
                    fontSize: '14px',
                    marginTop: '20px'
                }}>
                    <p style={{ margin: '5px 0' }}>
                        Si tienes alguna pregunta urgente, puedes contactarnos a:
                    </p>
                    <p style={{ margin: '5px 0', fontWeight: 'bold', color: '#001c4d' }}>
                        soporte@transferisok.com
                    </p>
                </div>
            </div>
        </div>
    );
}

export default RegistroError;
